export const toNumber = value => parseInt(value, 10)
